import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { AuthenticationService } from '../../../services/authentication.service';
import { CommonService } from '../../../services/common.service';
import { ProfileService } from '../../../services/profile.service';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-profile-user-data',
  templateUrl: './profile-user-data.component.html',
  styleUrls: ['./profile-user-data.component.scss']
})
export class ProfileUserDataComponent implements OnInit {


    public url: any;
    public isProfile = false;
    public isMutualFriend = false;
    public isActiveFeed = false;
    public isIntroProfile = false;
    public isFollowers = false;
    public isFollowings = false;
    public isLatestPhotos = false;
    public isFriends = false;

    public active = 1;

    pagecode: string = "profile-user-data";
    module: string = "profile";
    accessdenied: boolean = false;

    id: string = "0";
    myId: string = this.authentication._authentication.id;

    constructor(private sanitizer: DomSanitizer, private route: ActivatedRoute,
        private router: Router, private profileService: ProfileService,
        private authentication: AuthenticationService,
        private common: CommonService) {


    }

    userData: any = {};
    connectionStatus: any = "not_friend";


    ngOnInit(): void {

        let map: any = this.route.paramMap;
        this.id = map.destination._value.id;

        if (this.id == this.authentication._authentication.id)
            this.router.navigate(['profile/myprofile']);
        else {

            this.route.params.subscribe(val => {
                this.authentication.checkUserPageAccess(this.authentication._authentication.id, this.pagecode).subscribe(
                    (res: any) => {
                        if (res.success && res.data) {

                            var pageURL = this.router.routerState.snapshot.url;
                            this.authentication.addUserPageView(pageURL, this.pagecode, this.module);

                            this.getUserProfile(this.id);
                        }
                        else {
                            this.accessdenied = true;
                        }
                    },
                    (err: any) => {
                        console.error("checkUserPageAccess", err);
                        this.accessdenied = true;
                    }
                );
            });

        }


    }

    sendConnectionRequestInvitation() {

        this.profileService.sendConnectionRequestInvitation(this.authentication._authentication.id, this.userData.id).subscribe(
            (res: any) => {
                if (res) {
                    //means connection sent
                    this.connectionStatus = "sent_conn";
                }
            },
            (err: any) => {
                console.error("sendConnectionRequestInvitation", err);
            }
        );

    }

    removeConnectionFromMyList(connectionUserId: any) {
        this.ignoreUserConnection(this.myId, connectionUserId);
        this.ignoreUserConnection(connectionUserId, this.myId);
    }

    ignoreUserConnection(requestedUserId: any, toUserId: any) {

        this.profileService.ignoreUserConnection(requestedUserId, toUserId).subscribe(
            (res: any) => {
                if (res) {
                    //means connection sent
                    this.connectionStatus = "not_friend";
                }
            },
            (err: any) => {
                console.error("ignoreUserConnection", err);
            }
        );
    }

    acceptUserConnection(userId: any, userConnectionId: any) {

        this.profileService.acceptUserConnection(userId, userConnectionId).subscribe(
            (res: any) => {
                if (res) {
                    //means connection sent
                    this.connectionStatus = "friend";
                }
            },
            (err: any) => {
                console.error("acceptUserConnection", err);
            }
        );
    }


    //showNotFoundPanel: boolean = false;


    getUserProfile(profileUserId: any) {
        this.profileService.getUserProfile(profileUserId, this.authentication._authentication.id).subscribe(
            (res: any) => {
                if (res.success) {
                    if (res.data != null) {
                        if (res.data.userData.coverPhoto == null)
                            res.data.userData.coverPhoto = 'assets/images/forest.jpeg';
                        this.userData = res.data.userData;
                        this.connectionStatus = res.data.connectionStatus;
                    }
                    else
                        console.error("Web/UserProfile", "response data is null");
                }
                else {
                    this.common.ShowMessage('info', res.error_message, '');
                    console.error("Web/UserProfile", res.error_message);
                }
            },
            (err: any) => {
                console.error("Web/UserProfile", err);
            }

        );
    }

}
